<script>import { Portal } from '../../Portal';
export let withinPortal = false;
export let target = 'body';
</script>

{#if withinPortal}
	<Portal {target}>
		<slot ref={target} />
	</Portal>
{:else}
	<slot />
{/if}
